import { type ReactNode } from "react";

import { Checkbox } from "@vega-core/components/shadcn/checkbox";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { type NestedOptionType } from "../types";

type SubOptionProps = {
  option: NestedOptionType;
  index: number;
  totalOptions: number;
  isSelected: boolean;
  onSelect: () => void;
  renderLabel?: (option: NestedOptionType) => ReactNode;
};

export const SubOption = ({
  option,
  index,
  totalOptions,
  isSelected,
  onSelect,
  renderLabel,
}: SubOptionProps) => {
  const isFirst = index === 0;
  const isLast = index === totalOptions - 1;

  return (
    <div
      className={cnTwMerge(
        "flex gap-3 items-center cursor-pointer hover:bg-background/component text-text/primary px-2 py-2 mx-2 rounded-companyBorderRadius",
        isFirst && "rounded-t-companyBorderRadius",
        isLast && "rounded-b-companyBorderRadius",
      )}
      data-option-label={option.label}
      data-suboption
      onClick={(e) => {
        e.stopPropagation();
        onSelect();
      }}
    >
      <Checkbox
        checked={isSelected}
        onCheckedChange={onSelect}
        onClick={(e) => e.stopPropagation()}
      />
      <span className="text-text/primary body-semi-large-medium">
        {renderLabel ? renderLabel(option) : option.label}
      </span>
    </div>
  );
};
